import * as React from 'react';
import { useFragment } from 'react-relay';
import ReactMarkdown from 'react-markdown';
import { awardsListItemFragment } from './AwardsListItem.relay';
import type { AwardsListItemPropsType } from './types';

const AwardsListItem: React.FC<AwardsListItemPropsType> = ( props: AwardsListItemPropsType ) => {
    const awardsListItem = useFragment( awardsListItemFragment, props.awardsListItem );

    return (
        <div className="flex py-[35px] border-t border-[#e2e2e2]">
            <div className="basis-[130px] shrink-0 mr-[35px] text-center max-[700px]:basis-[50px] max-[700px]:mr-[15px]">
                <img src={ process.env.HOST + awardsListItem.logoUrl } className="max-w-[130px] max-[700px]:max-w-[40px]" />
            </div>
            <div>
                <h4 className="text-[#668272] font-[BonnCaps,Arial,sans-serif] uppercase text-[13px] tracking-[1px] leading-6 font-normal [.no-bonncapps_&]:font-[Arial,sans-serif]">{awardsListItem.awardName}</h4>
                <ReactMarkdown>{ awardsListItem.awardText }</ReactMarkdown>
            </div>
        </div>
    );
};

export { AwardsListItem };
